import $ from "jquery";
import DataTable from "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import "datatables.net-select-bs5";
import "datatables.net-searchpanes-bs5";

$.fn.dataTable.ext.errMode = "none";

const _render = {
  _: "[<br>]",
  sp: "[]",
};

new DataTable("#serviceTable", {
  responsive: true,
  columns: [
    {
      title: "Name",
      data: "name",
      type: "html-utf8",
      className: "col-1",
      render: (d, t, r) => {
        if (t === "display")
          return `<a href="/user/submit/${d}" data-bs-toggle="tooltip" data-bs-title="${r.description}">${d}</a>`;
        return d;
      },
    }, // 0
    { title: "Inputs", data: "content.inputs", render: _render }, // 1
    { title: "Biomarkers", data: "content.biomarkers", render: _render }, // 2
    { title: "Diseases", data: "content.diseases", render: _render }, // 3
    { title: "Targets", data: "content.target", render: _render }, // 4
    { title: "Date", data: "content.date", className: "col-1" }, // 5
    // { title: 'Keywords', data: 'content.keywords', visible: false, render: _render, },
    {
      title: "Infos",
      data: "content.service",
      className: "dt-center col-1",
      type: "html",
      orderable: false,
      searchable: false,
      render: (d, t, r) => {
        if (t == "display")
          return (
            "" +
            `<a href="/user/submit/${r.name}" title="Try ${r.name}"><span class="fa fa-play"/></a> ` +
            `<a href="/services/${d ? d : r.name}" target="_blank" title="More info on ${r.name}"><span class="fa fa-question"/></a> ` +
            ""
          );
        return d;
      },
    },
    { visible: false },
  ],
  ajax: {
    url: "/api/v1.0/pipelines",
    dataSrc: "",
  },
  paging: false,
  layout: {
    top1: {
      searchPanes: {
        cascadePanes: true,
        orderable: false,
      },
    },
    topStart: {
      search: {
        placeholder: "Quick search ...",
      },
    },
    topEnd: $("#helpText"),
    bottomStart: "info",
    bottomEnd: null,
  },
  columnDefs: [
    {
      searchPanes: { show: false },
      targets: [0, 5, 6],
    },
    {
      searchPanes: { orthogonal: "sp" },
      targets: [1, 2, 3, 4],
    },
  ],
});
